<template>
  <div class="list-base">
    <div class="list-contain">
      <div
        v-for="item in list"
        :key="item.name"
        class="list-item"
        @click="goInfo(item)"
      >
        <img v-if="item.icon" :src="item.icon" />
        <img v-else src="@/assets/imgs/default-app-icon.png" />
        <div class="list-desc">
          <p>{{ item.name }}</p>
          <p>
            {{ item.intro }}
          </p>
          <p>{{ item.developerName }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AppList',
  props: {
    list: {
      type: Array
    }
  },
  setup(props, { root }) {
    const goInfo = (item) => {
      root.$router.push({
        path: '/app-info',
        query: {
          appId: item.appId || '',
          developerId: item.developerId || ''
        }
      })
    }
    return {
      goInfo
    }
  }
})
</script>

<style lang="less" scoped>
.list-base {
  box-sizing: border-box;
  padding-bottom: 64px;
  .list-contain {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    .list-item {
      margin: 16px 16px 0 0;
      width: 389px;
      height: 147px;
      background: #ffffff;
      box-shadow: 0px 24px 24px 0px rgba(220, 224, 239, 0.24);
      border-radius: 12px;
      position: relative;
      display: flex;
      padding: 24px 27px 0 43px;
      box-sizing: border-box;
      cursor: pointer;
      img {
        height: 90px;
        width: 90px;
        box-sizing: border-box;
        border-radius: 22.5%;
        border: 1px solid #e6e6e6;
      }
      .list-desc {
        position: relative;
        overflow: hidden;
        margin-left: 15px;
        & p:first-child {
          font-size: 18px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 500;
          color: #0a0d0f;
          line-height: 25px;
        }
        & p:nth-child(2) {
          font-size: 14px;
          color: rgba(10, 13, 15, 0.6);
          line-height: 1.5;
          min-height: 40px;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
          margin: 4px 0 10px 0;
        }
        & p:last-child {
          font-size: 12px;
          color: rgba(10, 13, 15, 0.4);
          line-height: 17px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &:nth-child(3n + 3) {
        margin-right: 0px;
      }
      &:hover {
        border-radius: 10px;
        border-color: transparent;
        box-shadow: 0px 24px 40px 0px rgba(202, 207, 227, 0.6);
      }
      &:nth-child(3n + 3) {
        margin-right: 0px;
      }
    }
  }
}
</style>
